



























































import { RankingActionEnum } from '@empathybroker/tsclient-play/dist/enums/ranking-action.enum';
import { Result, ScoreCriteriaDetail } from '@empathybroker/tsclient-search';

import { ColorEnum, RootScoreCriteriaDetailTypeEnum } from '../../enums';

import { ExplainUtils } from '../../utils';

import Badge from '../badge.component.vue';
import ExplainResultTooltip from './explain-result-tooltip.component.vue';

export default {
  name: 'explain-results-score-histogram',
  props: {
    results: {
      type: Array,
      required: true
    },
    maxResultsCount: {
      type: Number,
      required: true
    },
    selectedResultIds: {
      type: Array,
      default: () => []
    },
    detailed: Boolean,
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    Badge,
    ExplainResultTooltip
  },
  computed: {
    maxTotalScoreValue: function (): number {
      return Math.max(...this.results.map(this.getResultTotalScoreNormalizedValue));
    }
  },
  data: function () {
    return {
      hoveredResultId: undefined
    };
  },
  methods: {
    getResultTotalScoreNormalizedValue: function (result: Result): number {
      let totalScoreNormalizedValue = this.getResultTotalScoreValue(result);
      totalScoreNormalizedValue -= (this.getResultCriteriaDetailValue(result, RootScoreCriteriaDetailTypeEnum.BUSINESS_RULES) || 0);
      return totalScoreNormalizedValue;
    },
    getResultCriteriaDetailValue: function (result: Result, criteriaDetailType: (RootScoreCriteriaDetailTypeEnum | string)): number {
      const resultScoreCriteria = ExplainUtils.getResultScoreCriteria(result);
      const resultScoreCriteriaDetail = (resultScoreCriteria.details[criteriaDetailType] as ScoreCriteriaDetail);
      if (!!resultScoreCriteriaDetail) {
        return resultScoreCriteriaDetail.value;
      }
    },
    getResultTotalScoreValue: function (result: Result): number {
      return Number(ExplainUtils.getResultScoreCriteria(result).value);
    },
    getResultRankingState: function (result: Result): RankingActionEnum {
      const resultRankingScoreValue = this.getResultTotalScoreValue(result) - this.getResultTotalScoreNormalizedValue(result);
      if (resultRankingScoreValue > 0) {
        return RankingActionEnum.BOOST;
      } else if (resultRankingScoreValue < 0) {
        return RankingActionEnum.BURY;
      }
    },
    getResultContainerClasses: function (result: Result): string[] {
      const resultContainerClasses = [];
      const baseClass = 'epb-explain-results-score-histogram__result-container';
      const resultRankingState = this.getResultRankingState(result);
      if (!!resultRankingState) {
        resultContainerClasses.push(`${ baseClass }--${ resultRankingState.toLowerCase() }`);
      }
      if (this.hoveredResultId === result.id) {
        resultContainerClasses.push(`${ baseClass }--hovered`);
      }
      if (this.selectedResultIds.includes(result.id)) {
        resultContainerClasses.push(`${ baseClass }--selected`);
      }
      return resultContainerClasses;
    },
    getResultBarHeightPct: function (result: Result, criteriaDetailType?: (RootScoreCriteriaDetailTypeEnum | string)): number {
      let scoreValue: number;
      if (!!criteriaDetailType) {
        scoreValue = (this.getResultCriteriaDetailValue(result, criteriaDetailType) || 0);
      } else {
        scoreValue = this.getResultTotalScoreNormalizedValue(result);
      }
      return (scoreValue / this.maxTotalScoreValue) * 100;
    },
    getResultBarColor: function (criteriaDetailType: (RootScoreCriteriaDetailTypeEnum | string)): ColorEnum {
      const colorOptions = {
        [RootScoreCriteriaDetailTypeEnum.CATALOG_DEFINITION]: () => ColorEnum.PURPLE,
        [RootScoreCriteriaDetailTypeEnum.QUERY_CONTEXT]: () => ColorEnum.GREY,
        [RootScoreCriteriaDetailTypeEnum.USER_CONTEXT]: () => ColorEnum.YELLOW,
        default: () => ColorEnum.PRIMARY
      };
      return (colorOptions[criteriaDetailType] || colorOptions.default)();
    },
    getResultScoreCriteriaDetailTypes: function (result: Result): (RootScoreCriteriaDetailTypeEnum | string)[] {
      return Object.keys(ExplainUtils.getResultScoreCriteria(result).details)
        .filter((criteriaDetailType: (RootScoreCriteriaDetailTypeEnum | string)) =>
          (criteriaDetailType !== RootScoreCriteriaDetailTypeEnum.BUSINESS_RULES) &&
          (this.getResultCriteriaDetailValue(result, criteriaDetailType) > 0));
    },
    isResultPositionVisible: function (result: Result, index: number): boolean {
      return (!(index % Math.floor(this.maxResultsCount / 5)) || (result.id === this.hoveredResultId));
    }
  },
  watch: {
    results: function (): void {
      this.hoveredResultId = undefined;
    }
  }
};
